import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import './CommentTemplateSelector.css';

const API = '/api/cms';

const CATEGORY_LABELS = {
  general: 'Общие',
  status_change: 'Смена статуса',
  client_response: 'Ответ клиенту',
  internal: 'Внутренние',
  custom: 'Пользовательские'
};

const CommentTemplateSelector = ({ token, onSelect, onClose }) => {
  const [templates, setTemplates] = useState([]);
  const [filter, setFilter] = useState('');
  const [categoryFilter, setCategoryFilter] = useState('');
  const [loading, setLoading] = useState(true);

  const h = { Authorization: `Bearer ${token}` };

  const loadTemplates = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/templates`, { headers: h });
      setTemplates(res.data || []);
    } catch (e) {
      console.error('Ошибка загрузки шаблонов:', e);
    } finally {
      setLoading(false);
    }
  }, [h]);

  useEffect(() => {
    loadTemplates();
  }, [loadTemplates]);

  const filteredTemplates = templates.filter(t => {
    if (categoryFilter && t.category !== categoryFilter) return false;
    if (filter) {
      const q = filter.toLowerCase();
      return t.name.toLowerCase().includes(q) || t.content.toLowerCase().includes(q);
    }
    return true;
  });

  const handleSelect = async (template) => {
    onSelect(template);
    // Отмечаем использование
    try {
      await axios.put(`${API}/templates/${template._id}`, {
        usageCount: (template.usageCount || 0) + 1,
        lastUsedAt: new Date()
      }, { headers: h });
    } catch (e) { /* игнорируем */ }
    onClose();
  };

  const grouped = {};
  filteredTemplates.forEach(t => {
    if (!grouped[t.category]) grouped[t.category] = [];
    grouped[t.category].push(t);
  });

  return (
    <div className="template-selector-overlay" onClick={onClose}>
      <div className="template-selector" onClick={e => e.stopPropagation()}>
        <div className="template-selector-header">
          <h3>📝 Выберите шаблон комментария</h3>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>

        <div className="template-selector-filters">
          <input
            type="text"
            placeholder="🔍 Поиск шаблона..."
            value={filter}
            onChange={e => setFilter(e.target.value)}
            className="search-input"
          />
          <select value={categoryFilter} onChange={e => setCategoryFilter(e.target.value)}>
            <option value="">Все категории</option>
            {Object.entries(CATEGORY_LABELS).map(([value, label]) => (
              <option key={value} value={value}>{label}</option>
            ))}
          </select>
        </div>

        <div className="template-selector-body">
          {loading ? (
            <p className="loading-state">⏳ Загрузка шаблонов...</p>
          ) : filteredTemplates.length === 0 ? (
            <p className="empty-state">Нет шаблонов. Создайте их в панели администратора.</p>
          ) : (
            Object.entries(grouped).map(([category, items]) => (
              <div key={category} className="template-group">
                <h4>{CATEGORY_LABELS[category] || category} ({items.length})</h4>
                <div className="template-list">
                  {items.map(t => (
                    <div key={t._id} className="template-item" onClick={() => handleSelect(t)}>
                      <div className="template-item-header">
                        <strong>{t.name}</strong>
                        <span className="template-usage">Исп.: {t.usageCount || 0}</span>
                      </div>
                      <p className="template-item-content">{t.content}</p>
                    </div>
                  ))}
                </div>
              </div>
            ))
          )}
        </div>

        <div className="template-selector-footer">
          <button className="btn btn-outline" onClick={onClose}>✕ Закрыть</button>
        </div>
      </div>
    </div>
  );
};

export default CommentTemplateSelector;